import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Image from "next/image";

type Award = {
    id: string;
    title: string;
    subTitle: React.ReactNode;
    bg: string;
    imgUrl: string;
};

interface LayerVisualItemProps {
    index: number;
    awards: Award[];
    scrollYProgress: any;
}

const LayerVisualItem: React.FC<LayerVisualItemProps> = ({
    index,
    awards,
    scrollYProgress,
}) => {
    const [currentStep, setCurrentStep] = useState(0);

    useEffect(() => {
        const p = scrollYProgress; // 0..1 (number)
        const dead = 0.6; // vùng chết đầu vào

        if (p < dead) {
            setCurrentStep(0);
        } else {
            // chia đều phần (dead..1] thành 2 đoạn còn lại
            const q = (p - dead) / (1 - dead); // q: 0..1
            if (q < 0.9) setCurrentStep(1);
            else setCurrentStep(2);
        }
    }, [scrollYProgress]);

    const award = awards[index];
    const isVisible = index <= currentStep;
    const isActive = index === currentStep;

    const getScale = () => {
        if (index === currentStep) return 1;
        if (index === currentStep - 1) return 0.9;
        if (index === currentStep - 2) return 0.8;
        return 1;
    };

    const getY = () => (currentStep - index) * -45;

    if (!isVisible) return null;

    return (
        <motion.div
            className="absolute inset-0 w-full"
            style={{ zIndex: 10 + index }}
            animate={{ scale: getScale(), y: getY() }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
        >
            <motion.div
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: 100, opacity: 0 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                className="w-full max-w-[1440px] mx-auto h-[400px] mb-28 flex max-lg:flex-col justify-between items-center gap-4"
            >
                {/* Left text */}
                <motion.h2
                    className="w-1/3 text-[32px]/[40px] max-lg:hidden"
                    animate={{ opacity: isActive ? 1 : 0 }}
                    transition={{ duration: 0.3 }}
                >
                    {award.title}
                </motion.h2>

                {/* Card */}
                <div
                    className="rounded-[24px] p-4 "
                    style={{
                        background: award.bg,
                    }}
                >
                    <div className="bg-white p-4 rounded-[24px]">
                        <Image
                            src={award.imgUrl}
                            height={500}
                            width={300}
                            alt=""
                            className="max-lg:w-[200px] max-lg:h-[300px]"
                        />
                    </div>
                </div>

                {/* Right text */}
                <motion.div
                    className="w-1/3 max-lg:w-full max-lg:text-center"
                    animate={{ opacity: isActive ? 1 : 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <p className="text-[32px]/[40px] text-[#202020] max-lg:text-2xl max-sm:text-xl lg:hidden">{award.title}</p>
                    <p className="text-base max-sm:text-sm max-lg:mt-5 max-sm:mt-2 text-[#646464]">{award.subTitle}</p>
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default LayerVisualItem;
